

































































import Job from "@/store/entities/job";
import { Component, Vue } from "vue-property-decorator";
import Ajax from '../../../lib/ajax';
@Component({})
export default class OccupationAdd extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  job:Job=new Job();
  
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

      occupation: [],
      occupationItems: ["Mühendis", "Şef"], 
      
      city: [],
      cityItems: ["İstanbul", "Ankara"], 

      category: [],
      categoryItems: ["Proje", "Şantiye Şefi"], 

    };
  }

  async created() {
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
  async saveJob() {
  await Ajax.post(
        '/api/services/app/Admin/SaveJob',this.job
      );

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();


   
  }

openFileInput() {
  const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
  if (fileInput) {
    fileInput.click();
  }
}

handleFileChange(event) {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
    // Resim seçildiğinde bu kod çalışır
    const imagePreview = this.$refs.imagePreview as HTMLImageElement | undefined;
    if (imagePreview) {
      // Seçilen resmi önizleme alanında göster
      const reader = new FileReader();
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          imagePreview.src = e.target.result;
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }
}
  
  }
